/**
 * 繁體中文語言資源
 */

export const zhTWResources = {
  translation: {
    // 認證相關
    auth: {
      login: "使用 Google 帳戶登入",
      login_with: "使用以下方式登入",
      logout: "登出",
      login_failed: "登入失敗：請稍後再試",
      terms_agreement: "登入即表示您同意我們的<1>服務條款</1>和<3>隱私政策</3>",
    },
    // 使用者相關
    user: {
      profile: "個人資料",
      welcome: "歡迎, {{name}}！",
    },
    // 頁面相關
    pages: {
      protected: "受保護頁面",
    },
    // 狀態相關
    status: {
      loading: "載入中...",
      error_occurred: "發生錯誤",
      error_message: "應用程式遇到了問題，請重新整理頁面或稍後再試。",
    },
    // 錯誤相關
    errors: {
      page_not_found: "頁面不存在",
      page_not_found_message: "您所尋找的頁面不存在或已被移動。",
      permission_denied: "權限不足",
      permission_denied_message:
        "您沒有權限訪問此頁面。如果您認為這是錯誤，請聯絡管理員。",
      go_back: "返回上一頁",
      contact_admin: "聯絡管理員",
    },
    // 操作相關
    actions: {
      refresh_page: "重新整理頁面",
      language_toggle: "切換語言",
    },
    // 共用按鈕和文字
    common: {
      back_to_home: "返回首頁",
      go_to_profile: "前往個人資料",
    },
    // 主題相關
    theme: {
      switchToLight: "切換至亮色模式",
      switchToDark: "切換至暗色模式",
      light_mode: "亮色模式",
      dark_mode: "暗色模式",
    },
    // 法律相關
    legal: {
      privacy_policy: "隱私政策",
      terms_of_service: "服務條款",
      back_to_login: "返回登入頁面",
      last_updated: "最後更新：2025年5月5日",
    },
    // 首頁相關
    home: {
      title: "首頁",
      overview: "概覽",
      activity: "活動",
      notifications: "通知",
    },
    // 網站相關
    website: {
      title: "網站",
      pages: "頁面",
      templates: "模板",
      domains: "網域",
    },
    // SEO 相關
    seo: {
      title: "SEO",
      overview: "概覽",
      keywords: "關鍵字",
      performance: "效能",
    },
    // 資源相關
    resources: {
      title: "資源",
      media: "媒體",
      documents: "文件",
      uploads: "上傳",
    },
    // 分析相關
    analytics: {
      title: "分析",
      overview: "概覽",
      traffic: "流量",
      conversion: "轉換",
    },
    // 行銷相關
    marketing: {
      title: "行銷",
      campaigns: "活動",
      email: "電子郵件",
      social: "社群媒體",
    },
    // 專案相關
    project: {
      title: "專案",
      create: "建立專案",
      edit: "編輯專案",
      delete: "刪除專案",
      details: "專案詳情",
      list: "專案列表",
      templates: "專案模板",
    },
    // 設定相關
    settings: {
      title: "設定",
      account: "帳戶",
      billing: "帳單",
      team: "團隊",
    },
    // 任務相關
    task: {
      title: "任務",
      create: "建立任務",
      edit: "編輯任務",
      delete: "刪除任務",
      details: "任務詳情",
    },
    // 聊天相關
    chat: {
      title: "聊天",
      page_chat: "頁面聊天",
      project_chat: "專案聊天",
      type_message: "在此輸入訊息...",
      send: "發送",
      no_messages: "尚無訊息",
      start_conversation: "開始與 Glow 助手對話",
      load_error: "無法載入聊天訊息",
      send_error: "無法發送訊息",
      no_context: "未指定聊天上下文",
      user_info_failed: "無法獲取用戶資訊",
      building_assistant: "建站助手",
      assistant_description: "幫助您建置網站",
      suggestions: "建議",
      info: "資訊",
      available_suggestions: "可用建議",
      no_suggestions: "沒有可用的建議",
      ask_for_suggestions: "向助手詢問建議",
      apply_suggestion: "應用",
      current_context: "當前上下文",
      context_page: "頁面 ID：{{id}}",
      context_project: "專案 ID：{{id}}",
      assistant_capabilities: "助手功能",
      quick_reply: {
        help: "你能幫我什麼？",
        suggestions: "給我一些建議",
        next_steps: "我接下來應該做什麼？",
      },
      capabilities: {
        suggestions: "提供設計和內容建議",
        questions: "回答關於網站建置的問題",
        content: "幫助生成網站內容",
      },
      suggestion_examples: {
        layout: {
          title: "改善首頁布局",
          description: "優化您的首頁布局以提高用戶參與度",
        },
        content: {
          title: "添加吸引人的內容",
          description: "為您的關於我們版塊創建吸引人的內容",
        },
        design: {
          title: "增強視覺設計",
          description: "改善配色方案和排版以強化品牌識別",
        },
      },
    },
  },
};
